export const accessToken = `edgsNSAToken`;
export const accessTokenExpiry='edgsNSATokenExpiry'
export const checkAccessTokenTimeout = 500;
export const promiseTimeout = 30000;